import { EmojiResource } from '@atlaskit/emoji/resource';
import type { EmojiProvider } from '@atlaskit/emoji/types';

export const getEmojiProvider = (cloudId: string, userId: string | null): Promise<EmojiProvider> =>
	new EmojiResource({
		providers: [
			{ url: '/gateway/api/emoji/standard' },
			{ url: '/gateway/api/emoji/atlassian' },
			{ url: `/gateway/api/emoji/${cloudId}/site` },
		],
		currentUser: userId ? { id: userId } : undefined,
	}).getEmojiProvider();
